import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";
import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { ptlEnvs } from "@/tz/go/egaz/osci/ptl/comn";

/*
 *  Chnage My Information Services
 * !== 나의정보수정 서비스 ==!
 */

export const BASE = {
    path: `${ptlEnvs.base}/usr/info`,
    api: `${process.env.REACT_APP_API_PTL_COMN}/api/v1/osci/ptl/usr/info`,
    nodes: [],
};

export const URLS = {
    osci0103002q: `${BASE.path}/osci0103002q`, // Chnage My Information !==  나의정보==!
    osci0103003s: `${BASE.path}/osci0103003s`, // Chnage My Information !==  나의정보수정 ==!
};

export const APIS = {
    // Search My Information !==  나의정보조회 ==!
    getMyInfo: (usrIdntfId: any) => {
        return api.get(`${BASE.api}/${usrIdntfId}`);
    },

    // update My Information !==  나의정보수정 ==!
    updateMyInfo: (data: any) => {
        return api.put(`${BASE.api}/${data.usrIdntfId}`, { ...data });
    },
};

export const SF_USR_INFO: TFormSchema = {
    id: "form_orgInfo",
    schema: {
        psnTin: { type: "text", label: "L_TIN", required: true },
        orgCd: { type: "code", label: "L_ORG_CD", area: "orgCd", popupSize: "md", required: true },
        frgnrYn: {
            type: "radio",
            label: "L_FRGNR_YN",
            options: [
                { label: "Citizen", value: "Y" },
                { label: "Foreigner", value: "N" },
            ],
            defaultValue: "N",
            // required: true,
        },
        orgRppnYn: {
            type: "radio",
            label: "L_ORG_RPPN_YN",
            options: [
                { label: "Head of Organization", value: "Y" },
                { label: "General", value: "N" },
            ],
            defaultValue: "N",
            required: true,
            readOnly: true,
        },
        aplcCntyCd: { type: "code", label: "L_APLC_CNTY_CD", area: "cntyCd", popupSize: "md", required: true },
        usrNm: { type: "text", label: "L_USR_NM", required: true },
        usrMoblNo: { type: "text", label: "L_USR_MOBL_NO", required: true },
        usrEmlAddr: {
            type: "text",
            label: "L_USR_EML_ADDR",
            pattern: { value: /[a-z0-9]+@[a-z]+.[a-z]{2,3}/, message: "이메일 형식이 올바르지 않습니다" },
            controlSize: 10,
            required: true,
        },
        rsdtAddr: { type: "text", label: "L_RSDT_ADDR", required: true, controlSize: 10 },
        nextRppnXtrnUsrUuid: { type: "code", label: "L_NEXT_RPPN", area: "orgUsr", popupSize: "md", required: true },
        cstmOfceCd: {
            label: "L_CSTM_OFCE_CD",
            type: "code",
            area: "cstmCd",
            popupSize: "md",
            popupParams: {
                // dclrYn: "Y",
            },
        },
    },
};

// Customs Office Code is a mandatory field for ORG(TBS, ZBS, WMA) !== TBS, ZBS, WMA 기관은 세관 사무소 코드 필수 입력 ==!
// export const CSTM_OFCE_CD_RQRD_ARR = new Array("OGAM0001", "OGAM0035", "OGAZ0001");
